import Vue from 'vue'
import numeral from '@/plugins/numeral'
import { checkField } from '@/services/fields/fieldCheck'

Vue.filter('percentage', function (value) {
  const rate = checkField(value, null)
  return rate !== null ? numeral(rate / 100).format('0[.]0 %') : '-'
})
